import countdown from '../../../design/baseline/current/versus-countdown-390x844.png';
import gameplay from '../../../design/baseline/current/versus-gameplay-390x844.png';
import lobby from '../../../design/baseline/current/lobby-private-390x844.png';
import menu from '../../../design/baseline/current/menu-390x844.png';
import power from '../../../design/baseline/current/versus-power-1024-390x844.png';
import ranking from '../../../design/baseline/current/rankings-versus-390x844.png';

export const shots = { countdown, gameplay, lobby, menu, power, ranking };
